import React from "react";
import "./News.css";
import me from "../../assets/imgs/me.jpg";
import RightFixed from '../RightFixed/RightFixed'

export default function News() {
  return (
    <div className="news">
      <div className="bosh-container">
        <div className="news-in">
          <h1>Notifications</h1>

          <div className="flx-btns">
            <button>All</button>
            <button>Responses</button>
          </div>

          <div className="per-flex">
            <div className="left-line"></div>
            <img src={me} alt="me" />
            <div className="per-info">
              <h4>Piter Parker </h4>
              <p>about 1 hours ago</p>
            </div>
          </div>
          <div className="bt-green">
            <button>Order notification</button>
            <button>Your stats</button>
          </div>
          <div className="fix-div"><RightFixed /></div>
        </div>
      </div>
    </div>
  );
}
